// extracted by mini-css-extract-plugin
export default {"root":"DQrsF6WUz5-YLfz9st2_B"};